export enum HeaderDataHooks {
  TITLE = 'header-title',
}
